import namespace from "@rdfjs/namespace";
const builder = namespace("http://commontag.org/ns#");
export const strict = builder;
export const loose = builder;
